import React from "react";
import { useTranslation } from "react-i18next";

const NoResults = () => {
    const { t } = useTranslation();
    return <div className={`accessories_no_results`}>{t("Accessories.noResults")}</div>;
};

export default NoResults;
